import createSvgIcon from '../Utils/CreateSvgIcon';

export const Manual = createSvgIcon(
  <path d="M2 9L2 4H4L4 9H2ZM11 11L11 4H13L13 11L20 11V4L22 4V13L13 13V20H11V13L4 13L4 20H2L2 11L11 11Z" />,
  'Manual',
);
